import type { JsonObject } from '@backstage/types';
import {
  QuestionnaireCategory,
  StepCollection,
  ValueMapping,
} from './Review/QuestionnaireResults/schema';

export interface OutcomePillar {
  name: string;
  title: string;
  outcomes: Outcome[];
}

export interface Outcome {
  title: string;
  value: string;
  isTarget: boolean;
}

export interface OutcomeAssessmentResultOptions {
  pillars: OutcomePillar[];
}

export interface PreviewItem {
  label: string;
  value: string;
}

export interface ScaffolderExtras {
  preview: Record<string, PreviewItem>;
  context: Record<string, any>;
}

export type FormDataWithExtras = JsonObject;

export type ValueMappings = Record<string, ValueMapping[]>;

export interface AeToolkit {
  label: string;
  url: string;
}

export type ScorringKind =
  | 'ladder'
  | 'percent'
  | 'group'
  | 'like-love'
  | 'outcomes'
  | 'preview';

export interface Mandatory {
  tooltip: string;
  fields: string[];
}
export interface FieldOverrides {
  [key: string]: {
    type: string;
  };
}
export interface PreviewOptions {
  key: string;
  label: string;
  scoring: ScorringKind;
  submitText?: string;
  categories?: QuestionnaireCategory[];
  mandatory?: Mandatory;
  mappings?: ValueMappings;
  pillars?: OutcomePillar[];
  toolkit?: AeToolkit;
  fieldOverrides?: FieldOverrides;
}

const defaultExtras: ScaffolderExtras = {
  context: {},
  preview: {},
};

let extraBag = {
  ...defaultExtras,
};

export function resetExtras() {
  extraBag = {
    ...defaultExtras,
  };
}

export function setFieldPreview(fieldKey: string, data: PreviewItem) {
  extraBag.preview = {
    ...extraBag.preview,
    [fieldKey]: data,
  };
}

export function getPreviewExtra(fieldKey: string): PreviewItem {
  return extraBag.preview[fieldKey];
}

export function resetFormData(candidate: any, excludeList: string[] = []) {
  Object.keys(candidate ?? {})
    .filter(it => !excludeList.includes(it))
    .forEach(k => {
      candidate[k] = null;
    });
}

export function setExtra(key: string, value: any) {
  extraBag.context = {
    ...extraBag.context,
    [key]: value,
  };
}

export function getExtra<T>(key: string): T {
  return extraBag.context[key];
}

export function getPreviewOptions(
  steps: StepCollection,
): PreviewOptions | undefined {
  const maybeWelcome = steps
    .flatMap(s => {
      return Object.values(s.mergedSchema.properties ?? {});
    })
    .find(prop => {
      return prop['ui:field'] === 'WelcomeComponent';
    });
  return maybeWelcome?.['ui:preview'];
}
